var BaseViews = require('../../../common/base');
require('./favourite-button/favourite-button.scss');
var FavouriteButtonView = BaseViews.LayoutView.extend({
    className: 'fmcy-favourite-button',
    template: require('./favourite-button/favourite-button.html'),
    initialize: function (options) {
        this.options = _.defaults(
            options || {},
            {
                isFavourite: false,
                appChannel: null
            }
        );
    },
    events: {
      'click': 'onClick'
    },
    initialize: function () {
      var self = this;
      this.model = new Backbone.Model({
        isFavourite: this.options.isFavourite
      });
      var throttledRequest = _.debounce(_.bind(self._delayedRequest, self), 1000);
      this.listenTo(this.model, 'change:isFavourite', function () {
        self._toggleFavourite();
        throttledRequest();
      });
    },
    onClick: function () {
      var self = this;
      if (this.model.get('isFavourite') === true) {
        this.model.set('isFavourite', false);
      } else {
        this.model.set('isFavourite', true);
      }
    },
    _delayedRequest: function () {
      this.trigger('toggle:favourite', this.model.get('isFavourite'));
    },
    _toggleFavourite: function () {
      if (this.model.get('isFavourite') == true) {
        this.$el.addClass('farm-favourited');
      } else {
        this.$el.removeClass('farm-favourited');
      }
    },
    setFavourite: function (isFavourite) {
      this.model.set('isFavourite', isFavourite);
    },
    serializeData: function () {
        var self = this;
        return {
            isFavourite: true,
            size: this.options.size
        };
    },
    onRender: function () {
      this._toggleFavourite();
    }
});

module.exports = FavouriteButtonView;



/** WEBPACK FOOTER **
 ** ./assets/js/common/menu/common/favourite-button.js
 **/